import React, { useRef } from "react";
import { InputGroup, Button } from "@blueprintjs/core";
import DefaultToaster from "../DefaultToaster";

export default function CopyInput({
  value,
  message = "Text copied to clipboard."
}) {
  const inputRef = useRef(null);

  function selectAllText() {
    if (!inputRef.current) return;
    inputRef.current.select();
  }

  function copyToClipboard() {
    selectAllText();
    document.execCommand("copy");

    DefaultToaster.show({
      message,
      icon: "tick-circle",
      timeout: 1000
    });
  }

  return (
    <InputGroup
      defaultValue={value}
      inputRef={inputRef}
      onClick={selectAllText}
      readOnly
      rightElement={
        <Button small minimal icon="clipboard" onClick={copyToClipboard} />
      }
    />
  );
}
